
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 16.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.004 3.518a7.969 7.969 0 017.194 4.486 7.96 7.96 0 01-7.194 4.486A7.96 7.96 0 011.81 8.004a7.969 7.969 0 017.194-4.486zm0-1.631c-4.078 0-7.561 2.537-8.972 6.117 1.41 3.581 4.894 6.118 8.972 6.118 4.078 0 7.561-2.537 8.972-6.118-1.411-3.58-4.894-6.117-8.972-6.117zm0 4.078a2.04 2.04 0 110 4.079 2.04 2.04 0 010-4.079zm0-1.631a3.676 3.676 0 00-3.67 3.67 3.676 3.676 0 003.67 3.67 3.676 3.676 0 003.67-3.67 3.676 3.676 0 00-3.67-3.67z"}})])
          )
        }
      }
    